import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const AddCarServiceSchema = z.object({
  name: z.string().min(3),
  description: z.string().optional(),
  price: z.string().min(1),
  duration: z.string().optional(),
  category: z.string().min(3),
  available: z.boolean(),
  company: z.string().optional(),
  subCategory: z.string().optional(),
  
});

export type AddCarServiceSchemaType = z.infer<typeof AddCarServiceSchema>;

export async function addCarServiceData(formData: AddCarServiceSchemaType) {
  try {
    const response = await axiosInstance.post(`${config.apiUrl}/car-services`, {
      ...formData,
    });
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
